import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";

const UNIT_OPTIONS = [
  { value: "kg", label: "Quilograma (kg)" },
  { value: "g", label: "Grama (g)" },
  { value: "L", label: "Litro (L)" },
  { value: "ml", label: "Mililitro (ml)" },
  { value: "un", label: "Unidade (un)" },
];

const CATEGORY_OPTIONS = [
  { value: "carnes", label: "Carnes" },
  { value: "laticinios", label: "Laticinios" },
  { value: "hortifruti", label: "Hortifuti" },
  { value: "graos", label: "Graos e Cereais" },
  { value: "bebidas", label: "Bebidas" },
  { value: "temperos", label: "Temperos e Condimentos" },
  { value: "embalagens", label: "Embalagens" },
  { value: "limpeza", label: "Limpeza" },
  { value: "outros", label: "Outros" },
];

const IngredientModal = ({ open, onClose, onSave, ingredient }) => {
  const [form, setForm] = useState({
    name: "",
    unit: "un",
    category: "outros",
    current_cost: "",
    minimum_stock: "",
  });

  useEffect(() => {
    if (ingredient) {
      setForm({
        name: ingredient.name || "",
        unit: ingredient.unit || "un",
        category: ingredient.category || "outros",
        current_cost: ingredient.current_cost || "",
        minimum_stock: ingredient.minimum_stock || "",
      });
    } else {
      setForm({
        name: "",
        unit: "un",
        category: "outros",
        current_cost: "",
        minimum_stock: "",
      });
    }
  }, [ingredient, open]);

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.name.trim()) return;
    onSave({
      name: form.name.trim(),
      unit: form.unit,
      category: form.category,
      current_cost: form.current_cost || 0,
      minimum_stock: form.minimum_stock || 0,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {ingredient ? "Editar Ingrediente" : "Novo Ingrediente"}
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              label="Nome do Ingrediente"
              value={form.name}
              onChange={handleChange("name")}
              fullWidth
              required
              autoFocus
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              select
              label="Unidade"
              value={form.unit}
              onChange={handleChange("unit")}
              fullWidth
            >
              {UNIT_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              select
              label="Categoria"
              value={form.category}
              onChange={handleChange("category")}
              fullWidth
            >
              {CATEGORY_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Custo Unitario (R$)"
              type="number"
              value={form.current_cost}
              onChange={handleChange("current_cost")}
              fullWidth
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Estoque Minimo"
              type="number"
              value={form.minimum_stock}
              onChange={handleChange("minimum_stock")}
              fullWidth
              inputProps={{ min: 0, step: 0.001 }}
              helperText="0 = sem alerta"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!form.name.trim()}
          sx={{
            backgroundColor: "#2563eb",
            "&:hover": { backgroundColor: "#1d4ed8" },
          }}
        >
          {ingredient ? "Salvar" : "Criar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IngredientModal;
